import './header.scss';
import React, {PropTypes} from 'react';

const AccordionHeader = props =>
    <div className='accordion-header'>
        <div
            className='primary-content'
            onClick={props.onClick}
        >
            <div className='accordion-controls'>
                <span className='accordion-icon'/>
            </div>
            <div className='accordion-title'>{props.title}</div>
        </div>
        {props.isExpanded && <div className='secondary-content'>{props.secondaryNode}</div>}
    </div>;

AccordionHeader.displayName = 'AccordionHeader';
AccordionHeader.propTypes = {
    isExpanded: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    secondaryNode: PropTypes.node,
    title: PropTypes.node.isRequired
};

export default AccordionHeader;



// WEBPACK FOOTER //
// ./src/shared/components/accordion/header.js